import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { ProviderType } from '../DocumentVault.meta';
import { queryKeys } from './queryKeys';

interface DeleteEntityParams {
  clientId: string;
  path: string;
  objectPath: string;
  objectProviderType: ProviderType;
  providerType: ProviderType;
  currentYear: number | null;
}

const deleteEntity = ({ clientId, objectPath, objectProviderType }: DeleteEntityParams) => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/DeleteObject', {
      clientId,
      objectPath,
      providerType: objectProviderType,
    }),
    { method: 'DELETE' },
  );
};

export const useDeleteEntityMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteEntity, {
    onSuccess(_, { clientId, path, providerType, currentYear }) {
      queryClient.refetchQueries(
        queryKeys.listDocumentVaultEntities(clientId, path, providerType, currentYear),
        { active: true },
      );
    },
  });
};
